/* eslint-disable no-console */

const noop = () => { /* noop */ };
export const info = (console && console.info) ? console.info.bind(console) : noop;
export const warn = (console && console.warn) ? console.warn.bind(console) : noop;
export const error = (console && console.error) ? console.error.bind(console) : noop;
